module.exports = __webpack_public_path__ + "static/img/classroom_wisdom.85e763ae.jpg";